if(!customElements.get('anchors-highlights')) {
  class ComponentAnchorsHighlights extends HTMLElement {
    constructor() {
      super();
      
      this.buttons = this.querySelectorAll('anchor-button');
      this.targetElements = [];
      this.buttons.forEach(button => {
        this.targetElements.push(document.getElementById(button.dataset.anchorId));
      })
      this.visibleIndex = undefined;
      this.highlightButton();
      window.addEventListener("scroll", (event) => {
        this.highlightButton();
      });

      

    }

    highlightButton(){
      this.targetElements.forEach((elem, index) => {
        if(elem.offsetTop - window.innerHeight / 2 < window.scrollY)
          this.visibleIndex = index;
      })

      this.buttons.forEach(button => {
        button.classList.remove('selected');
      })

      if(this.visibleIndex){
        this.buttons[this.visibleIndex].classList.add('selected');
      }
      else{
        this.buttons[0].classList.add('selected');
      }
    }

  }
  customElements.define('anchors-highlights', ComponentAnchorsHighlights);
}